var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectBasedOursourcing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D7CBF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,133.8c-44.7,17.1-77.7,58-83.4,107.2h61C188.6,200.7,196.1,161.4,209.5,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.3,158.2c-5.9-15.9-16-32.9-24.3-32.9c-5.8,0-15.9,10.3-24.3,32.9c-8.3,22.4-13.4,51.4-14.6,82.8h77.8 C293.7,209.5,288.6,180.6,280.3,158.2L280.3,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.7,353.8c5.9,15.9,16,32.9,24.3,32.9c5.8,0,15.8-10.3,24.3-32.9c8.3-22.4,13.4-51.4,14.6-82.8h-77.8 C218.3,302.5,223.4,331.4,231.7,353.8L231.7,353.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.5,378.2c44.7-17.1,77.7-58,83.4-107.2h-61C323.4,311.3,315.9,350.6,302.5,378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,378.2c-2-4.2-4-8.8-5.9-13.9c-9.5-25.5-15.3-58.2-16.5-93.3h-61C131.8,320.2,164.8,361.1,209.5,378.2 L209.5,378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,80V0h-80v30h28.8l-58,58C362.1,52.4,310.6,32.9,256,32.9c-54.6,0-106.1,19.5-146.8,55.1l-58-58H80V0H0 v80h30V51.2l58,58C52.4,149.9,32.9,201.4,32.9,256c0,54.6,19.5,106.1,55.1,146.8l-58,58V432H0v80h80v-30H51.2l58-58 c40.7,35.6,92.2,55.1,146.8,55.1c54.6,0,106.1-19.5,146.8-55.1l58,58H432v30h80v-80h-30v28.8l-58-58 c35.6-40.7,55.1-92.2,55.1-146.8S459.6,149.9,424,109.2l58-58V80L512,80z M256,416.7c-0.1,0-0.1,0-0.2,0 C167.3,416.6,95.3,344.6,95.3,256c0-88.6,72.1-160.7,160.7-160.7c0.1,0,0.1,0,0.2,0c88.5,0.1,160.5,72.2,160.5,160.7 C416.7,344.6,344.6,416.7,256,416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.9,241h61c-5.6-49.2-38.7-90.1-83.4-107.2c2,4.2,4,8.8,5.9,13.9C317.9,173.3,323.6,205.9,324.9,241z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBasedOursourcing);
export default __webpack_public_path__ + "static/media/project_based_oursourcing.ce33c73f8df9fdde552af16605eb1598.svg";
export { ForwardRef as ReactComponent };